export default "__VITE_ASSET__rCDtjlH4__"